import WithTracker from "src/components/Tracker";
import CouponList from "src/containers/CouponList";
import Questionnaire from "src/containers/Questionnaire";
import Coupon from "src/containers/Coupon";
import LandingPage from "src/containers/LandingPage";

export const SMS_CODE = "0000";
export const phoneExpireTime = 15 * 60 * 1000;
export const lineOAUrl =
  window.LINE_AT_URL || process.env.REACT_APP_LINE_URL || "";
export const baseRoute =
  window.BASE_ROUTE || process.env.REACT_APP_BASE_ROUTE || "";
export const liffId = process.env.REACT_APP_LIFF_ID;
export const stage = process.env.REACT_APP_NODE_ENV;
export const shopId = process.env.REACT_APP_SHOP_ID || "";
export const GA_trackId = process.env.REACT_APP_TRACKING_ID || "";
export const host = process.env.REACT_APP_HOST_DOMAIN || "";
export const routes = [
  {
    path: "/",
    exact: true,
    key: "landingPage",
    element: <LandingPage />,
  },
  {
    path: "/couponList",
    exact: true,
    key: "CouponList",
    element: (
      <WithTracker ga="view_coupon_list">
        <CouponList />
      </WithTracker>
    ),
  },
  {
    path: "/form",
    key: "Questionnaire",
    element: (
      <WithTracker ga="view_form">
        <Questionnaire />
      </WithTracker>
    ),
  },
  {
    path: "/coupon/:couponId",
    key: "Coupon",
    element: (
      <WithTracker ga="view_the_coupon">
        <Coupon />
      </WithTracker>
    ),
  },
];
console.log(stage);
